// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module_root-3CDUA","word":"index-module_word-iRaUO"};